import React from 'react';

import Link from 'next/link';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Modal from '@components/common/Modals/Modal/Modal';
import Text from '@components/common/Text/Text';
import { getRoute, ROUTE } from '@services/http/Route';

import css from './AccountBlockedModal.module.scss';

type AccountBlockedModalProps = {
    isAccountBlockedModalVisible: boolean;
    onHide?: () => void;
};
const AccountBlockedModal = ({ isAccountBlockedModalVisible, onHide }: AccountBlockedModalProps) => {
    const { t } = useTranslateLpc('lpc-authentication');

    return (
        <Modal
            onHide={onHide}
            visible={isAccountBlockedModalVisible}
            hideCloseButton={true}
            customClass={css.account_blocked_modal}
        >
            <div>
                <span onClick={onHide} className={css.account_blocked_modal__close_button}>
                    <img src="/front-static/icons/navigation/close-pink.png" alt="close" />
                </span>
                <div className={css.account_blocked_modal__container}>
                    <div className={css.account_blocked_modal__container__left}>
                        <img src={'/front-static/images/authentication/shame-on-you.gif'} alt={'congrats'} />
                    </div>
                    <div className={css.account_blocked_modal__container__right}>
                        <Text
                            variant={'body_03'}
                            color={'txt-primary'}
                            customClass={css.account_blocked_modal__container__right__title}
                        >
                            {t('blocked-modal.title')}
                        </Text>
                        <Text
                            variant={'body_02'}
                            color={'txt-primary'}
                            customClass={css.account_blocked_modal__container__right__text}
                        >
                            <Text
                                htmlText={t('blocked-modal.text-identified')}
                                customClass={css.modal__text}
                                variant={'body_02'}
                                color={'ui-primary'}
                                html
                            />
                        </Text>
                        <div className={css.account_blocked_modal__container__right__button}>
                            <Link href={getRoute(ROUTE.LPC.HELP_CENTER.CONTACT)}>
                                <Button
                                    customClass={css.account_blocked_modal__container__right__button__cta}
                                    variant="primary"
                                >
                                    {t('blocked-modal.cta')}
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AccountBlockedModal;
